import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-395211fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "div-page-content-desc"
}
const _hoisted_2 = { id: "identification-title-h1" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_4 = {
  key: 0,
  id: "identification-description-sub"
}
const _hoisted_5 = {
  key: 1,
  id: "identification-description-shorter-sub"
}
const _hoisted_6 = {
  key: 1,
  class: "div-page-content-area"
}
const _hoisted_7 = { id: "identification-subtitle-signicat-h3" }
const _hoisted_8 = { class: "signicat-description" }
const _hoisted_9 = { class: "signicat-buttons" }
const _hoisted_10 = ["value"]
const _hoisted_11 = {
  class: "radio-button-label",
  for: "rb-ftn"
}
const _hoisted_12 = ["value"]
const _hoisted_13 = {
  class: "radio-button-label",
  for: "rb-sbid"
}
const _hoisted_14 = { class: "two-button-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_custom_alert_note = _resolveComponent("custom-alert-note")!
  const _component_custom_spinner = _resolveComponent("custom-spinner")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.store.getters.translate("identification")), 1),
          _hoisted_3,
          (_ctx.store.getters.getAppointmentSelection)
            ? (_openBlock(), _createElementBlock("sub", _hoisted_4, _toDisplayString(_ctx.store.getters.translate("identification-description")), 1))
            : (_openBlock(), _createElementBlock("sub", _hoisted_5, _toDisplayString(_ctx.store.getters.translate("identification-description-short")), 1))
        ]))
      : _createCommentVNode("", true),
    (!_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.store.getters.translate("goto-identification")), 1),
          _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.store.getters.translate("identification-description-signicat")), 1),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", null, [
              _withDirectives(_createElementVNode("input", {
                id: "rb-ftn",
                type: "radio",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedAuthMethod) = $event)),
                value: _ctx.AuthMethod.FTN
              }, null, 8, _hoisted_10), [
                [_vModelRadio, _ctx.selectedAuthMethod]
              ]),
              _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.store.getters.translate("signicat-option-ftn")), 1)
            ]),
            _createElementVNode("div", null, [
              _withDirectives(_createElementVNode("input", {
                id: "rb-sbid",
                type: "radio",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedAuthMethod) = $event)),
                value: _ctx.AuthMethod.SBID
              }, null, 8, _hoisted_12), [
                [_vModelRadio, _ctx.selectedAuthMethod]
              ]),
              _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.store.getters.translate("signicat-option-sbid")), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("button", {
              id: "identification-return-button",
              class: "buttonReturn",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.doReturn && _ctx.doReturn(...args)))
            }, _toDisplayString(_ctx.store.getters.translate("generic-return")), 1),
            _createElementVNode("button", {
              id: "identification-continue-button",
              class: "buttonContinue",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.startLogin && _ctx.startLogin(...args)))
            }, _toDisplayString(_ctx.store.getters.translate("ok-local")), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.error === 'retryable error')
      ? (_openBlock(), _createBlock(_component_custom_alert_note, {
          key: 2,
          id: "identification-error",
          onRedirect: _cache[4] || (_cache[4] = ($event: any) => (_ctx.error = '')),
          title: _ctx.store.getters.translate('identification-error'),
          text: _ctx.store.getters.translate('identification-error-text'),
          subtext: _ctx.store.getters.translate('identification-error-return'),
          button: _ctx.store.getters.translate('generic-return')
        }, null, 8, ["title", "text", "subtext", "button"]))
      : _createCommentVNode("", true),
    _createVNode(_component_custom_spinner, {
      loading: !_ctx.completed
    }, null, 8, ["loading"])
  ], 64))
}